const contentful = require("contentful");

export default contentful.createClient({
    space: "fskry955olww",
    accessToken: "Nslfnwp2wop2jaFRnHuF7hyxNDphAdEjs2KdleQYSN0",
  });